"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = exports.ProductEditorTableContainer = void 0;
var table_container_1 = require("./table.container");
Object.defineProperty(exports, "ProductEditorTableContainer", { enumerable: true, get: function () { return table_container_1.ProductEditorTableContainer; } });
var table_container_2 = require("./table.container");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return table_container_2.MemoizedProductEditorTableContainer; } });
